<template>
  <div>
    <h1 class="mb-4 text-2xl font-bold">Tambah Profil Jurusan</h1>
    <form @submit.prevent="submit">
      <div class="mb-4">
        <label class="block">Visi</label>
        <textarea v-model="form.visi" class="w-full input" required></textarea>
      </div>
      <div class="mb-4">
        <label class="block">Misi</label>
        <textarea v-model="form.misi" class="w-full input" required></textarea>
      </div>
      <div class="mb-4">
        <label class="block">Akreditasi</label>
        <input v-model="form.akreditasi" class="w-full input" required />
      </div>
      <button type="submit" class="btn btn-primary">Simpan</button>
      <Link :href="route('profil-jurusan.index')" class="ml-2 btn"
        >Kembali</Link
      >
    </form>
  </div>
</template>

<script setup>
import { inject } from "vue";
import { Link, useForm } from "@inertiajs/vue3";
const route = inject('route');
const form = useForm({ visi: "", misi: "", akreditasi: "" });
function submit() {
  form.post(route("profil-jurusan.store"));
}
</script>
